export default __webpack_public_path__ + "47f0ddaea980c82c652c75b94cc66504.png";